<div
  *ngIf="event"
  [style]="'--bg-color:' + (event.color ?? '#3158e3')"
  class="wrapper text-color-{{ getContrastYIQ(event.color ?? '#3158e3') }}"
>
  <div class="container">
    @if (!rejected) {
      <header class="text-center">
        <div class="heading mb-3" *ngIf="event.with_picture">
          <cf-avatar
            *ngIf="event.picture as picture"
            [src]="$any(picture.image)"
            [rounded]="$any(picture.rounded)"
            size="xl"
          ></cf-avatar>
          <cf-avatar *ngIf="!event.picture" [userName]="event.organizer_name" size="xl"></cf-avatar>
        </div>

        <h2 class="mb-2">{{ event.summary }}</h2>
        <cf-text weight="500" size="lg" color="white">
          <cf-text-truncate
            color="white"
            [count]="50"
            [text]="event.description"
            entityName=" {{ 'description' | translate }}"
          ></cf-text-truncate>
        </cf-text>

        <cf-booking-information
          *ngIf="isTouch$ | async"
          [day]="event.start"
          [time]="time"
          [timezone]="event.timezone"
          [duration]="event.duration | duration"
          [participantsTmp]="participantsTmp"
          [location]="event.event_location"
          class="mt-4 text-force-white"
        >
          <ng-template #participantsTmp>
            <cf-participant-list
              [participants]="participants"
              [hideParticipants]="true"
              [role]="event.role"
            ></cf-participant-list>
          </ng-template>
        </cf-booking-information>
      </header>
    }

    <section class="personal-information" [class.m-auto]="rejected">
      @if (!rejected) {
        <div class="step personal-information">
          <div class="step-header d-xl-none">
            <cf-text size="md" weight="600"> {{ "booking.cancel_event" | translate }} </cf-text>
          </div>

          <div class="row g-5">
            <div class="col-xl-6 d-none d-xl-block">
              <div class="card">
                <cf-booking-information
                  *ngIf="(isTouch$ | async) === false"
                  [day]="event.start"
                  [time]="time"
                  [timezone]="event.timezone"
                  [duration]="event.duration | duration"
                  [participantsTmp]="participantsTmp"
                  [location]="event.event_location"
                  class="pt-5 pb-5 ps-5 pe-5"
                >
                  <ng-template #participantsTmp>
                    <cf-participant-list
                      [participants]="participants"
                      [hideParticipants]="true"
                      [role]="event.role"
                    ></cf-participant-list>
                  </ng-template>
                </cf-booking-information>
              </div>
            </div>

            <div class="col-xl-6">
              <h3 class="mb-3 d-none d-xl-block">{{ "booking.cancel_event" | translate }}</h3>

              <cf-form-field class="mb-12">
                <cf-input-label> {{ "booking.cancel_event_reason" | translate }} </cf-input-label>
                <textarea cf-input [formControl]="reasonControl" rows="4"></textarea>
                <cf-input-error [error]="reasonControl.errors">
                  {{ "booking.cancel_event_reason" | translate }}
                </cf-input-error>
              </cf-form-field>

              <div class="action mt-4 d-flex">
                <cf-button
                  class="d-block w-100"
                  color="error"
                  className="w-100"
                  [disabled]="reasonControl.invalid"
                  (click)="submit()"
                  disableOnRequest
                  isLoadingBtn
                >
                  {{ "actions.cancel_event" | translate }}
                </cf-button>
              </div>
            </div>
          </div>
        </div>
      } @else {
        <div class="d-flex w-100 flex-column text-center">
          <h2 class="mb-1">{{ event.public_title }}</h2>
          <h3>{{ "booking.rejected_notification" | translate }}</h3>
        </div>
      }
    </section>

    @if (event.show_cal_frenzy_logo) {
      <footer class="text-center mt-auto">
        <a routerLink="/" cf-main-logo></a>
      </footer>
    }
  </div>
</div>
